import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.mask()
    this.element.addEventListener("input", () => this.mask())
  }

  mask() {
    const digits = this.element.value.replace(/\D/g, "").slice(0, 11)
    const parts = []
    if (digits.length > 0) parts.push(digits.slice(0, 3))
    if (digits.length > 3) parts.push(digits.slice(3, 6))
    if (digits.length > 6) parts.push(digits.slice(6, 9))
    if (digits.length > 9) parts.push(digits.slice(9, 11))

    if (parts.length <= 3) {
      this.element.value = parts.join(".")
    } else {
      this.element.value = `${parts[0]}.${parts[1]}.${parts[2]}-${parts[3]}`
    }
  }
}
